const { instance } = require('./url')

async function getDrawingAttributes() {
    return await instance.get('/admin/drawingattributes')
}

async function insertDrawingAttribute(attribute) {
    return await instance.post('/admin/drawingattributes', attribute)
}

async function updateDrawingAttribute(key, attribute) {
    return await instance.put('/admin/drawingattributes/' + key, attribute)
}

async function deleteDrawingAttribute(key) {
    return await instance.delete('/admin/drawingattributes/' + key)
}

export {
    getDrawingAttributes,
    insertDrawingAttribute,
    updateDrawingAttribute,
    deleteDrawingAttribute,
}
